import React from "react"
import classNames from "classnames"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import { getProductUrl, getNewOrderUrl } from "../../../shared/utils/routes"
import SlotsCalendar from "./SlotsCalendar"
import { fetchCalendarData } from "./duck"

const slotsCalendarModifiers = {
  "past": sl => moment(sl.starts_at).isBefore(),
  "active": sl => sl.stock_available,
  "inactive": sl => !sl.stock_available,
  "confirmed": sl => sl.display_as_confirmed
}

@connect(
  state => ({
    onSlotClickActionType: state.onSlotClickActionType,
    products: state.products,
    slots: state.slots.model,
    fetchDone: state.slots.fetchDone,
    fetchFailed: state.slots.fetchFailed,
    fetchLoading: state.slots.fetchLoading,
    loadedMaxVisibleDate: state.slots.maxVisibleDate,
  }),
  dispatch => bindActionCreators({
    fetchCalendarData,
  }, dispatch)
)
export default class ProductsCalendarWidget extends React.PureComponent {
  DAYS_INITIAL_LOAD_LIMIT = 60
  DAYS_LOAD_LIMIT = 90
  DAYS_LOAD_OFFSET = 0

  state = {
    maxVisibleDate: moment().endOf("month").add(this.DAYS_INITIAL_LOAD_LIMIT, "days").toDate()
  }

  subscriptions = []

  componentDidMount() {
    this._setupFetchOnWindowScrollHandler()
  }

  componentWillUnmount() {
    this.subscriptions.forEach(s => s.unsubscribe())
    this.subscriptions.length = 0
  }

  _setupFetchOnWindowScrollHandler() {
    const onWindowScroll = () => {
      if (!this._alreadyFetched && this._containerRef && st.domUtils.isElementInViewport(this._containerRef)) {
        this._alreadyFetched = true
        this.props.fetchCalendarData({ maxVisibleDate: this.state.maxVisibleDate })
      }
    }

    onWindowScroll()
    $(window).on("scroll", onWindowScroll)
    this.subscriptions.push({
      unsubscribe: () => $(window).off("scroll", onWindowScroll)
    })
  }

  handleSlotClick(slot) {
    if (!slot.stock_available) { return }
    const { onSlotClickActionType } = this.props
    if (onSlotClickActionType === "show_product") {
      window.location.href = getProductUrl(slot.product_id)
    } else {
      window.location.href = getNewOrderUrl({
        product_id: slot.product_id,
        product_variant_id: slot.product_variant_id,
        product_schedule_slot_id: slot.id,
      })
    }
  }

  handleNavigate({ maxVisibleDate }) {
    this.setState({ maxVisibleDate })
    if (moment(maxVisibleDate).add(this.DAYS_LOAD_OFFSET, "days").isAfter(this.props.loadedMaxVisibleDate)) {
      this.props.fetchCalendarData({
        maxVisibleDate: moment(maxVisibleDate).add(this.DAYS_LOAD_LIMIT, "days").toDate()
      })
    }
  }

  render() {
    const { products, slots, fetchDone, fetchFailed, fetchLoading, fetchCalendarData } = this.props
    const enableFrontendSlotsListing = !products.find(p => !p.enable_frontend_slots_listing)
    const defaultDate = new Date()
    const defaultView = enableFrontendSlotsListing ? "agenda" : "month"
    const refetch = () => this.props.fetchCalendarData({ maxVisibleDate: this.state.maxVisibleDate })
    return (
      <div className="ProductsCalendarWidget" ref={ref => this._containerRef = ref}>
        {fetchFailed && (
          <div className="alert alert-danger">
            {I18n.t("fe.common.loading_failed_message")} <a onClick={refetch}>{I18n.t("fe.common.click_to_load_again")}</a>
          </div>
        )}
        <div className="ProductsCalendarWidget-content">
          <SlotsCalendar
            defaultDate={defaultDate}
            defaultView={defaultView}
            slots={slots}
            modifiers={slotsCalendarModifiers}
            onSlotSelect={this.handleSlotClick.bind(this)}
            onNavigate={this.handleNavigate.bind(this)}
            />
        </div>
        <div hidden={!fetchLoading} className="ProductsCalendarWidget-loader">
          <i className="spinner fa fa-spin fa-circle-o-notch"></i>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/ProductsCalendarWidget/ProductsCalendarWidget.jsx